export default __webpack_public_path__ + "static/media/ic_share.c372c910.svg";